'use strict';

var React = require('react');

var SvgListMajor = function SvgListMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    y: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    y: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    y: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    y: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1Zm0-4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1Z"
  }));
};

exports.SvgListMajor = SvgListMajor;
